import React, { memo, useCallback } from 'react';
// material-ui
import { Box, Stack } from '@mui/material';
import moment from 'moment';
// icons
import { ReactComponent as TopRightIcon } from 'assets/icons/topRightIcon.svg';
// styles
import { IconWrapper, SubTitle, Title } from './../../styled';
// types
import { CardProps } from './../../types';

const ViolationCard: React.FC<CardProps> = ({ id = '', date, status, reference, description, handleClick }) => {
  const isOpen = status === 'open';

  const onHandleClick = useCallback(() => {
    handleClick?.(id);
  }, [handleClick, id]);

  return (
    <>
      <Stack flexDirection='row' alignItems='center' justifyContent='space-between'>
        <Box>
          <Title variant='subtitle2'>VRefNo</Title>
          <SubTitle>{reference}</SubTitle>
        </Box>

        <Box>
          <Title variant='subtitle2'>{isOpen ? 'Resolve By' : 'Closed Date'}</Title>
          <SubTitle>{moment(date).format('L')}</SubTitle>
        </Box>
      </Stack>

      <Stack flexDirection='row' alignItems='center' justifyContent='space-between' gap={2}>
        <Box flex={1}>
          <Title variant='subtitle2'>Description</Title>
          <SubTitle>{description}</SubTitle>
        </Box>

        <IconWrapper cypress-id={`${isOpen ? 'open' : 'close'}ViolationCard${id}-button`} onClick={onHandleClick}>
          <TopRightIcon />
        </IconWrapper>
      </Stack>
    </>
  );
};

export default memo(ViolationCard);
